export default __webpack_public_path__ + "static/media/alivegameicon.4b496687.png";